import t from "@ext/localization/locale/translate";
import getCountArticles from "@ext/markdown/elements/view/render/logic/getCountArticles";
import type { PropertyValue, ViewRenderGroup } from "@ext/properties/models";
import { Display } from "@ext/properties/models/display";
import { getDisplayComponent } from "@ext/properties/models/displays";
import { memo } from "react";

interface ViewRenderContentProps {
	content: ViewRenderGroup[];
	display: Display;
	defs: PropertyValue[];
	orderby: PropertyValue[];
	groupby: string[];
	select: string[];
	className?: string;
	disabled?: boolean;
	commentId?: string;
	isPrint?: boolean;
	updateArticle?: (articlePath: string, property: string, value: string, isDelete?: boolean) => void;
}

const ViewRenderContent = memo(
	({ content, className, display, updateArticle, commentId, isPrint, ...otherProps }: ViewRenderContentProps) => {
		const noDefs = t("properties.validation-errors.no-defs");
		const noContent = t("properties.validation-errors.no-content");
		const count = getCountArticles(content);
		if (!count || !content.length) {
			return (
				<div className="error-message" data-focusable="true">
					{!count ? noContent : noDefs}
				</div>
			);
		}

		const Component = getDisplayComponent[isPrint ? Display.List : display];
		if (!Component) return null;

		return (
			<div data-component="view">
				<Component
					{...otherProps}
					className={className}
					commentId={commentId}
					content={content}
					isPrint={isPrint}
					updateArticle={updateArticle}
				/>
			</div>
		);
	},
);

export default ViewRenderContent;
